import React, { Component } from "react";
import i18n from "../../../../i18n";
import Input from "../../../utilities/Form/input";
import Radio from "../../../utilities/Form/radio";
import { StatusForm } from "../../../utilities/Const/StatusActive";
import DatePickerCustom from "../../../utilities/Form/datepicker";
import TextArea from "../../../utilities/Form/TextArea";
import { Sketch } from '@uiw/react-color';
import ColorInput from "../../../utilities/Form/ColorPicker";
import axios from "axios";
import cookieManager from "../../../../utils/cookieManager";
import InputNumber from "../../../utilities/Form/InputNumber";
import SwitchButton from "../../../utilities/Form/SwitchButton";
import Select2 from "../../../utilities/Form/Select2";
import { Table } from "react-bootstrap";

export class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        name: "",
        idBranch:null,
        branchCurrent:null,
        date: new Date(),
        description: [],
        status: 1,
      },
      branchList:[],
      branchText:i18n.t('Select Branch'),
       details:[],
      isUpdate: 0,
    };
    this.handler = this.handler.bind(this);
    this.runSubmit = this.runSubmit.bind(this);
  }

  handler(e) {
    var key = e.target.name;
    var value = e.target.value;
    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        [key]: value,
      },
    });
  }
  runSubmit() {
    const data={
      ...this.state.form,
      date:moment(this.state.form.date).format('YYYY-MM-DD'),
      details:this.state.details
    }
    return data;
  }
  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
    }
    return i18n.t(value);
  }

  handlerArray(value,index,name){
    this.setState((prevState) => {
      const details = prevState.details.map((d, idx) =>
        idx === index ? { ...d, [name]: value } : d
      );
      return { details };
    });
  }

  renderDetail(){
    return this.state.details.map((item,index)=>{
      return (<tr key={'item'+index}>  
        <td><Input
            type={"input"}
            labelfield={"false"}
            name={"name"}
            title={i18n.t("Name")}
            required
            disabled={true}
            value={item.name}
            handler={(e)=>{
              const value=e.target.value
              this.handlerArray(value,index,'name')
            }}
            error={this.renderError('name')}
        /></td>
        <td>
        <InputNumber
            // disabled={(this.state.typeSetting == 1)?true:false}
            id={"value"+index}
            name="value"
            placeholder={i18n.t("Value")}
            defaultValue={0}
            value={item?.value || 0}
            decimalsLimit={0}
            onValueChange={async (value,name)=>{
                this.handlerArray(value,index,'value')
            }}
            className='form-control  form-control-sm text-end'
            suffix={item?.type=='percentage'?' %':''}
            labelfield={"false"}
        />
        </td>
        <td>
          <ColorInput label="Primary Color" value={item.bgColor} onChange={(value)=>{this.handlerArray(value,index,'bgColor')}} />
        </td>
        <td>
        <SwitchButton
            labelfield={'false'} 
            onChange={(e)=>this.handlerArray(value,index,'calculate')}
            name={'calculate'}
            value={item?.calculate||false}
            checked={item?.calculate?true:false}
            className={'h-20px w-30px'}
        ></SwitchButton>
        </td><td>
        <SwitchButton
          labelfield={'false'} 
          onChange={(e)=>this.handlerArray(value,index,'status')}
          name={'status'}
          value={item?.status||false}
          checked={item?.status?true:false}
          className={'h-20px w-30px'}
      ></SwitchButton>
      </td>
      </tr>)
    })
    
  }

  getDetails(){
    const url = process.env.REST_URL + "marketing/ranking-sales/show";
    const token =  cookieManager.getUserToken();;
    const params={
      date:moment(this.state.form.date).format('YYYY-MM-DD'),
      idBranch:this.state.form.idBranch
    }
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        console.log(response)
        if (response && response.status === 200 && response.data) {
          const data= response.data.result
          this.setState({details:data.details,
            form:{
              ...this.state.form,
              description:data?.description,
              status:data?.status
            }})
        }
      })
      .catch((error) => {
        console.log('error',error)
      });
  }

  render() {
    const { data, isNewRecord,helperValue } = this.props;
    this.state.branchList=helperValue?.branch||[]
    return (
      <form>
        <div className="row mb-4">
          <div className="col-6">
          <DatePickerCustom
            name={"date"}
            title={i18n.t("Effecticve Date")}
            required={true}
            selected={this.state.form.date}
            onChange={(e) => {
                  this.setState({...this.state,form:{...this.state.form,date:e},},()=>{
                    this.getDetails()
                  })
              }
            }
            startDay={0}
            autoComplete={"off"}
            dateFormat="dd MMM yyyy"
            endDate={new Date()}
            showYearDropdown
            className="form-control form-control-sm"
            error={this.renderError("date")}
          />
          </div>
          <div className="col-6">
                <Select2 
                    isClearable={true}
                    name={'idBranch'}
                    size={4}
                    onChange={async (e)=>{
                        if(e!=this.state.form.branchCurrent){
                            await this.setState({
                              ...this.state,
                              form:{
                                ...this.state.form,
                                idBranch:e?.value||null,
                                branchCurrent:e
                              }
                            },()=>this.getDetails());
                        }
                    }}
                    options={this.state.branchList}
                    title={i18n.t("Branch")}
                    value={this.state.form.branchCurrent}
                    placeholder={this.state.branchText}
                />
            </div>
        </div>
        <TextArea
            name={"description"}
            title={i18n.t("Description")}
            value={this.state.form.description}
            handler={this.handler}
            error={this.renderError("description")}
            required
        />
        <Radio
          list={StatusForm}
          name={"status"}
          title={i18n.t("Status")}
          inline={false}
          value={this.state.form.status}
          handler={this.handler}
        />
        {this.state.details.length >0 && <Table>
          <thead>
            <tr>
              <th>Bobot</th>
              <th>Value</th>
              <th>Fill Color</th>
              <th>Calculate</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.renderDetail()}
          </tbody>
        </Table>}
      </form>
    );
  }
}

export default Form;
